const isIncludeSpecialCharacters = (text) => {
  const regex = /[^A-Za-z0-9]/gi;

  return regex.test(text);
};

export default isIncludeSpecialCharacters;
